import { useAtom } from 'jotai';
import { productVariantsAtom } from 'global/store';

export default function useColors(product) {
  const { variants, configurable_options } = product || {};

  const [selectedVariants] = useAtom(productVariantsAtom);
  const selectedCustomVariant = attr =>
    selectedVariants?.find(
      selected => selected?.attribute === 'custom' && selected?.uid === attr.uid
    );

  const hasColorOption =
    configurable_options &&
    configurable_options.some(option => option.attribute_code === 'v__rv');

  const variantsInStock =
    variants &&
    variants
      .slice()
      .sort((a, b) =>
        a.attributes[0].label.localeCompare(b.attributes[0].label)
      );

  const colorsInStock =
    variantsInStock &&
    variantsInStock.filter(variant =>
      variant.attributes.some(attr => selectedCustomVariant(attr))
    );

  const colors =
    configurable_options?.length > 1 ? colorsInStock : variantsInStock;

  const showColors =
    hasColorOption &&
    (configurable_options?.length === 1 || selectedVariants?.length > 0);

  return { showColors, colors };
}
